import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";
import { useState, useEffect } from "react";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireRole?: 'admin' | 'moderator' | 'user';
}

export function ProtectedRoute({ children, requireRole }: ProtectedRouteProps) {
  const { user, loading, checkRole } = useAuth();
  const [hasRole, setHasRole] = useState(false);
  const [checking, setChecking] = useState(!!requireRole);
  const location = useLocation();

  useEffect(() => {
    if (requireRole && user) {
      setChecking(true);
      checkRole(requireRole).then(result => {
        setHasRole(result);
        setChecking(false);
      });
    } else if (!requireRole) {
      setChecking(false);
    }
  }, [user, requireRole, checkRole]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location.pathname }} replace />;
  }

  if (requireRole && checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (requireRole && !hasRole) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}